import uiConfig from 'src/lib/ui/config';
import {
  ImageCoverView,
  ImageScaleView,
  ImageView,
  MovieClip,
} from '@play-co/timestep-core/ui';
import ResponsiveScene from './ResponsiveScene';
import { Transition } from 'src/game/logic/SceneManager';
import { height, width } from 'src/lib/ui/config/general';
import { waitForItPromise } from 'src/lib/utils';

export default class DebutScene extends ResponsiveScene {
  private banner: MovieClip;
  private sparkles: MovieClip;
  private kids: MovieClip;
  private smoke: MovieClip;
  private lines: MovieClip;
  private box: MovieClip;
  private godrays: MovieClip;

  constructor() {
    super(
      new ImageCoverView({
        ...uiConfig.buruburu.backgroundDefaults,
        ...uiConfig.buruburu.debut,
      }),
    );

    this.getView().tag = 'debutRoom';

    this.sparkles = new MovieClip({
      superview: this.getView(),
      defaultAnimation: 'sparkles',
      url: 'assets/ui/buruburu/debut/clip',
      scale: 0.7,
    });

    this.banner = new MovieClip({
      superview: this.getView(),
      defaultAnimation: 'signage',
      url: 'assets/ui/buruburu/debut/clip',
      scale: 0.7,
    });

    this.kids = new MovieClip({
      superview: this.getView(),
      defaultAnimation: 'mob',
      url: 'assets/ui/buruburu/debut/clip',
      scale: 0.7,
    });

    this.smoke = new MovieClip({
      superview: this.getView(),
      url: 'assets/ui/buruburu/debut/clip',
      scale: 0.7,
      visible: false,
      zIndex: height,
    });

    this.lines = new MovieClip({
      superview: this.getView(),
      defaultAnimation: 'lines',
      url: 'assets/ui/buruburu/debut/clip',
      scale: 0.7,
      visible: false,
    });

    this.box = new MovieClip({
      superview: this.getView(),
      url: 'assets/ui/buruburu/debut/clip',
      scale: 0.7,
      visible: false,
    });

    this.godrays = new MovieClip({
      superview: this.getView(),
      url: 'assets/ui/buruburu/debut/clip',
      defaultAnimation: 'box_burst_loop',
      scale: 0.7,
      visible: false,
    });

    new ImageView({
      superview: this.getView(),
      image: 'assets/ui/buruburu/debut/top_banner.png',
      width,
      height: 258,
      zIndex: height - 1,
    });
  }

  public transition(): Transition {
    return 'slide_forward';
  }

  public async launch() {
    await waitForItPromise(1000);
    this.banner.play('signage_up');
    await waitForItPromise(2000);
    this.banner.hide();

    this.smoke.show();
    this.smoke.play('rocket_smoke');

    void waitForItPromise(3000).then(() => {
      this.kids.hide();
      this.lines.show();
      this.sparkles.hide();
    });
  }

  public async onBeforeTransition() {
    const { width, height } = this.getView().style;
    this.banner.updateOpts({
      width,
      height,
      x: width / 2,
    });

    this.sparkles.updateOpts({
      width,
      height,
      x: width / 2,
      y: height / 2,
    });

    this.kids.updateOpts({
      width,
      height,
      x: width / 2,
      y: height * 0.73,
      zIndex: height - 1,
    });

    this.smoke.updateOpts({
      width,
      height,
      x: width / 2,
      y: height * 0.73,
      zIndex: height,
    });

    this.lines.updateOpts({
      width,
      height,
      x: width / 2,
      y: height * 0.56,
    });

    this.box.updateOpts({
      width,
      height,
      x: width / 2,
      y: height * 0.707,
    });

    this.godrays.updateOpts({
      width,
      height,
      x: width * 0.52,
      y: height * 0.796,
    });
  }

  public async spawnBox() {
    this.box.show();
    this.box.play('box_appear');
    this.lines.hide();

    await waitForItPromise(1000);
  }

  public async shakeBox() {
    const boxTop = new MovieClip({
      superview: this.getView(),
      defaultAnimation: 'box_open_top',
      url: 'assets/ui/buruburu/debut/clip',
      scale: 0.7,
      x: this.box.style.x,
      y: this.box.style.y,
      zIndex: height,
    });
    this.box.play('box_open_bottom');
    await waitForItPromise(1000);
    boxTop.removeFromSuperview();

    this.box.play('box_shake');
    await waitForItPromise(2000);
  }

  public async openBox() {
    this.box.play('box_burst_full');

    await waitForItPromise(1000);

    this.godrays.show();

    void waitForItPromise(2000).then(() => {
      this.box.hide();
    });
  }

  public async hideGodrays() {
    this.godrays.hide();
  }
}
